import * as React from 'react';
export const zionsSvg = React.forwardRef(function zionsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#2472C2',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm23.8 8.44-11.33 14.5h7.45c1.18 0 1.6-.12 3.53-2.56h.35c-.32.85-1.28 2.92-1.67 4.73a4.59 4.59 0 0 0-2.47-.58H7.78L19.43 9.68H10.7c-.6 0-.9.1-1.57 2.13h-.32V6.9c1 1.06 1.03 1.25 1.73 1.25H24l-.2.28z',
      }),
    ),
  );
});
zionsSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var zions = {
  category: 'brand',
  colorable: false,
  name: 'zions',
  svg: zionsSvg,
};
